var React = require('react');

function Smartphone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3333 1.66675H6.66667C6.22464 1.66675 5.80072 1.84234 5.48816 2.1549C5.17559 2.46746 5 2.89139 5 3.33341V16.6667C5 17.1088 5.17559 17.5327 5.48816 17.8453C5.80072 18.1578 6.22464 18.3334 6.66667 18.3334H13.3333C13.7754 18.3334 14.1993 18.1578 14.5118 17.8453C14.8244 17.5327 15 17.1088 15 16.6667V3.33341C15 2.89139 14.8244 2.46746 14.5118 2.1549C14.1993 1.84234 13.7754 1.66675 13.3333 1.66675ZM10.8333 17.5001H9.16667V16.6667H10.8333V17.5001ZM13.3333 15.8334H6.66667V4.16675H13.3333V15.8334Z","fill":"#36373A"}));
}

Smartphone.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Smartphone;

Smartphone.default = Smartphone;
